var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AiLoading"}},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('newItem.identifying')))]),_vm._v(" "),_c('div',{staticClass:"box"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263e28da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":["src","xlink:href"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai-loading.vue
// module id = rxtz
// module chunks = 1